'use es6';

import * as UIComponentsDateRangePresets from 'UIComponents/dates/dateRangePresets';
import { beginningOfTime, now } from 'UIComponents/core/SimpleDate';
export function AdsSimpleDateRange(obj = {}) {
  const {
    type = null,
    startDate = null,
    endDate = null
  } = obj;
  this.type = type;
  this.startDate = startDate;
  this.endDate = endDate;
}
/** Returns a date range preset object given a string */

export const getDateRangePresetForString = (presetName, startDate = null, endDate = null) => {
  // Support any date range preset names that UIComponents defines
  // NOTE: UIComponentsDateRangePresets[presetName] will be undefined if the string is not recognized as a named export of that module, and these exports could change in the future
  if (UIComponentsDateRangePresets[presetName]) {
    return new AdsSimpleDateRange(Object.assign({
      type: presetName
    }, UIComponentsDateRangePresets[presetName].getValue()));
  }

  switch (presetName) {
    case 'THIS_DAY':
      // Not used/supported by UIDateRange
      return new AdsSimpleDateRange(Object.assign({
        type: 'THIS_DAY'
      }, UIComponentsDateRangePresets.TODAY.getValue()));

    case 'LAST_DAY':
      // Not used/supported by UIDateRange
      return new AdsSimpleDateRange(Object.assign({
        type: 'LAST_DAY'
      }, UIComponentsDateRangePresets.YESTERDAY.getValue()));

    case 'ALL':
      return new AdsSimpleDateRange({
        type: 'ALL',
        startDate: beginningOfTime(),
        endDate: now()
      });

    case 'CUSTOM':
      return new AdsSimpleDateRange({
        type: 'CUSTOM',
        startDate,
        endDate
      });

    default:
      // This implementation throws an error when an unrecognized preset name is provided.
      throw new Error('Date range by type can not identify the string');
  }
};
export const PRESET_TYPES = {
  ALL: 'ALL',
  THIS_DAY: 'THIS_DAY',
  LAST_DAY: 'LAST_DAY',
  THIS_WEEK: 'THIS_WEEK',
  LAST_WEEK: 'LAST_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  LAST_THIRTY_DAYS: 'LAST_THIRTY_DAYS',
  LAST_THREE_MONTHS: 'LAST_THREE_MONTHS',
  THIS_QUARTER: 'THIS_QUARTER',
  LAST_QUARTER: 'LAST_QUARTER',
  THIS_YEAR: 'THIS_YEAR',
  LAST_YEAR: 'LAST_YEAR',
  CUSTOM: 'CUSTOM'
};